export const Good = {
    mainPath: 'Home',
    changeShop: 'Change store',
    curency: '$',
    addtoCart: 'Add To Cart',
    goodReview: 'Product Features',
    moreShops: 'More Shops',
    score: 'Score',
}